<template>
    <vx-card title="Profile" no-shadow>
      <ASpin :spinning="loading" :indicator="indicator">
        <a-tabs default-active-key="1" @tabClick="tabClick">
        <a-tab-pane key="1" tab="Profile" forceRender>
          <a-form :form="form_extra" @submit.prevent="handleSubmitProfile">
            <div class="flex flex-col mt-5">
              <Xupload class="profile-photo" url="/storage/public/" ref="profile" @change="profileUser"/>
              <div class="font-semibold ml-2">Edit Profile</div>
            </div>
             <a-divider/>
            <div class="flex flex-col">
              <div class="w-full md:w-1/2">
                <a-form-item label="FirsName">
                  <a-input placeholder="FirstName" v-decorator="['first_name',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
              <div class="w-full md:w-1/2">
                <a-form-item label="LastName">
                  <a-input placeholder="LastName" v-decorator="['last_name',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
              <div class="w-full md:w-1/2">
                <a-form-item label="Email">
                  <a-input placeholder="Email" v-decorator="['email_address',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
            </div>
            <a-divider/>
            <div class="flex items-center">
              <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
                Save Profile
              </a-button>
              <div class="pl-2">or</div>
              <a-button type="link" @click="$emit('changeTab','UserSettingsNotifications')">
                Cancel
              </a-button>
            </div>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Change extra information" forceRender>
          <a-form :form="form" @submit.prevent="handleOtherProfile">
            <a-form-item label="Address">
              <a-textarea v-decorator="['address',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"/>
            </a-form-item>
            <div class="flex space-x-4">
              <div class="w-1/2">
                <a-form-item label="Country">
                  <a-select
                    v-decorator="[`country`,{ initialValue:null,rules: [{ required: true,message:'This field is required.' }] }]"
                    placeholder="Country"
                    class="country"
                    allowClear
                    show-search
                    autocomplete="none"
                    :filter-option="filterOption"
                  >
                    <a-icon slot="suffixIcon" type="search" />
                    <a-select-option v-for="city in cities" :value="city.id">
                      {{ city.name }} ({{ city.code }})
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="w-1/2">
                <a-form-item label="State/Province">
                  <a-input v-decorator="['state',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
            </div>
            <div class="flex space-x-4">
              <div class="w-1/2">
                <a-form-item label="City">
                  <a-input v-decorator="['city',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
              <div class="w-1/2">
                <a-form-item label="Zip/Postal Code">
                  <a-input v-decorator="['zip_code',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"/>
                </a-form-item>
              </div>
            </div>
            <div class="flex space-x-4">
              <div class="w-full">
                <a-form-item label="Time Zone ">
                  <a-select
                    :filter-option="filterOption"
                    placeholder="(GMT-09:00) America/Nome"
                    show-search
                    v-decorator="['time_zone',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"
                  >
                    <a-select-option v-for="tz in timeZone" :value="tz.value">
                      {{ tz.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
<!--              <div class="w-1/2">-->
<!--                <a-form-item label="Locale">-->
<!--                  <a-select  v-decorator="['locale',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]" class="select" placeholder="English (United States)">-->
<!--                    <a-select-option value="en">-->
<!--                      English(Canada)-->
<!--                    </a-select-option>-->
<!--                    <a-select-option value="fa">-->
<!--                      Persian(United Kingdom)-->
<!--                    </a-select-option>-->
<!--                    <a-select-option value="American">-->
<!--                      American(United States)-->
<!--                    </a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </div>-->
            </div>

            <div class="flex space-x-4">

              <a-form-item label="Billing Rate" class="w-full md:w-1/2">
                <a-input addon-after="$/Hr"
                         v-decorator="['billing_rate',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"
                         default-value="0.00"
                />
              </a-form-item>
              <a-form-item label="Primary Phone" class="w-full md:w-1/2">
                <a-input v-decorator="['phone',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]"/>
              </a-form-item>

              <!--          <div class="w-1/2">-->
              <!--            <a-form-item label="Billing Rate Visibility">-->
              <!--              <a-select class="select" placeholder="All">-->
              <!--                <a-select-option value="1">-->
              <!--                  All-->
              <!--                </a-select-option>-->
              <!--                <a-select-option value="2">-->
              <!--                  Limited-->
              <!--                </a-select-option>-->
              <!--              </a-select>-->
              <!--            </a-form-item>-->
              <!--          </div>-->
            </div>
            <div class="flex flex-col md:flex-row space-x-4">
              <a-form-item label="Subscriber Type" class="w-full md:w-1/2">
                <a-select class="select" placeholder="All" v-decorator="['subscriber_type',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]">
                  <a-select-option value="1">
                    Lawyer
                  </a-select-option>
                  <a-select-option value="2">
                    Non-Lawyer
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Groups" class="w-full md:w-1/2">
                <a-select v-decorator="['group',{ initialValue: null,rules: [{ required: false,message:'This field is required.' }] }]">
                  <a-select-option v-for="group in groups" :value="group.id">
                    {{ group.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <!--        <a-form-item label="Job Title">-->
            <!--          <a-select class="select" placeholder="">-->
            <!--            <a-select-option value="1">-->
            <!--              Job 1-->
            <!--            </a-select-option>-->
            <!--            <a-select-option value="2">-->
            <!--              Job 2-->
            <!--            </a-select-option>-->
            <!--            <a-select-option value="3">-->
            <!--              Job 3-->
            <!--            </a-select-option>-->
            <!--          </a-select>-->
            <!--        </a-form-item>-->
            <h4 class="my-5" v-if="false">Permissions</h4>
            <div class="flex my-5" v-if="false">
              <a-form-item>
                <a-checkbox>
                  Adminstrator
                </a-checkbox>
              </a-form-item>
              <a-form-item>
                <a-checkbox>
                  Accounts
                </a-checkbox>
              </a-form-item>
              <a-form-item>
                <a-checkbox>
                  Reports
                </a-checkbox>
              </a-form-item>
              <a-form-item>
                <a-checkbox>
                  Billing
                </a-checkbox>
              </a-form-item>
            </div>
            <a-divider/>
            <div class="flex items-center">
              <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
                Save New Information
              </a-button>
              <div class="pl-2">or</div>
              <a-button type="link" @click="$emit('changeTab','UserSettingsNotifications')">
                Cancel
              </a-button>
            </div>
          </a-form>
        </a-tab-pane>
      </a-tabs>
      </ASpin>
      <a-modal :visible="visible" title="New Secure message" ok-text="Send message" cancel-text="Cancel" @cancel="onCancel">
        <a-form>
          <a-form-item label="User">
            <input class="ant-input">
          </a-form-item>
          <a-form-item label="Email">
            <input class="ant-input">
          </a-form-item>
          <a-divider/>
          <div class="flex space-x-3">
            <vs-button type="filled">Send Message</vs-button>
            <vs-button type="border">Cancel</vs-button>
          </div>
        </a-form>
      </a-modal>
    </vx-card>
</template>

<script>
    import * as TableColMailDrop from "./maildropTbl";
    import XTable from "../../../../components/x-table/XTable";
    import mixin from '../../../mixin/mixin'
    import axios from "@/axios";
    import Xupload from '@/components/x-upload/XUpload'

    const timeZone = [
      {"label":"(GMT-12:00) International Date Line West","value":"Etc/GMT+12"},
      {"label":"(GMT-11:00) Midway Island, Samoa","value":"Pacific/Midway"},
      {"label":"(GMT-10:00) Hawaii","value":"Pacific/Honolulu"},
      {"label":"(GMT-09:00) Alaska","value":"US/Alaska"},
      {"label":"(GMT-08:00) Pacific Time (US & Canada)","value":"America/Los_Angeles"},
      {"label":"(GMT-08:00) Tijuana, Baja California","value":"America/Tijuana"},
      {"label":"(GMT-07:00) Arizona","value":"US/Arizona"},
      {"label":"(GMT-07:00) Chihuahua, La Paz, Mazatlan","value":"America/Chihuahua"},
      {"label":"(GMT-07:00) Mountain Time (US & Canada)","value":"US/Mountain"},
      {"label":"(GMT-06:00) Central America","value":"America/Managua"},
      {"label":"(GMT-06:00) Central Time (US & Canada)","value":"US/Central"},
      {"label":"(GMT-06:00) Guadalajara, Mexico City, Monterrey","value":"America/Mexico_City"},
      {"label":"(GMT-06:00) Saskatchewan","value":"Canada/Saskatchewan"},
      {"label":"(GMT-05:00) Bogota, Lima, Quito, Rio Branco","value":"America/Bogota"},
      {"label":"(GMT-05:00) Eastern Time (US & Canada)","value":"US/Eastern"},
      {"label":"(GMT-05:00) Indiana (East)","value":"US/East-Indiana"},
      {"label":"(GMT-04:00) Atlantic Time (Canada)","value":"Canada/Atlantic"},
      {"label":"(GMT-04:00) Caracas, La Paz","value":"America/Caracas"},
      {"label":"(GMT-04:00) Manaus","value":"America/Manaus"},
      {"label":"(GMT-04:00) Santiago","value":"America/Santiago"},
      {"label":"(GMT-03:30) Newfoundland","value":"Canada/Newfoundland"},
      {"label":"(GMT-03:00) Brasilia","value":"America/Sao_Paulo"},
      {"label":"(GMT-03:00) Buenos Aires, Georgetown","value":"America/Argentina/Buenos_Aires"},
      {"label":"(GMT-03:00) Greenland","value":"America/Godthab"},
      {"label":"(GMT-03:00) Montevideo","value":"America/Montevideo"},
      {"label":"(GMT-02:00) Mid-Atlantic","value":"America/Noronha"},
      {"label":"(GMT-01:00) Cape Verde Is.","value":"Atlantic/Cape_Verde"},
      {"label":"(GMT-01:00) Azores","value":"Atlantic/Azores"},
      {"label":"(GMT+00:00) Casablanca, Monrovia, Reykjavik","value":"Africa/Casablanca"},
      {"label":"(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London","value":"Etc/Greenwich"},
      {"label":"(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna","value":"Europe/Amsterdam"},
      {"label":"(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague","value":"Europe/Belgrade"},
      {"label":"(GMT+01:00) Brussels, Copenhagen, Madrid, Paris","value":"Europe/Brussels"},
      {"label":"(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb","value":"Europe/Sarajevo"},
      {"label":"(GMT+01:00) West Central Africa","value":"Africa/Lagos"},
      {"label":"(GMT+02:00) Amman","value":"Asia/Amman"},
      {"label":"(GMT+02:00) Athens, Bucharest, Istanbul","value":"Europe/Athens"},
      {"label":"(GMT+02:00) Beirut","value":"Asia/Beirut"},
      {"label":"(GMT+02:00) Cairo","value":"Africa/Cairo"},
      {"label":"(GMT+02:00) Harare, Pretoria","value":"Africa/Harare"},
      {"label":"(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius","value":"Europe/Helsinki"},
      {"label":"(GMT+02:00) Jerusalem","value":"Asia/Jerusalem"},
      {"label":"(GMT+02:00) Minsk","value":"Europe/Minsk"},
      {"label":"(GMT+02:00) Windhoek","value":"Africa/Windhoek"},
      {"label":"(GMT+03:00) Kuwait, Riyadh, Baghdad","value":"Asia/Kuwait"},
      {"label":"(GMT+03:00) Moscow, St. Petersburg, Volgograd","value":"Europe/Moscow"},
      {"label":"(GMT+03:00) Nairobi","value":"Africa/Nairobi"},
      {"label":"(GMT+03:00) Tbilisi","value":"Asia/Tbilisi"},
      {"label":"(GMT+03:30) Tehran","value":"Asia/Tehran"},
      {"label":"(GMT+04:00) Abu Dhabi, Muscat","value":"Asia/Muscat"},
      {"label":"(GMT+04:00) Baku","value":"Asia/Baku"},
      {"label":"(GMT+04:00) Yerevan","value":"Asia/Yerevan"},
      {"label":"(GMT+04:30) Kabul","value":"Asia/Kabul"},
      {"label":"(GMT+05:00) Yekaterinburg","value":"Asia/Yekaterinburg"},
      {"label":"(GMT+05:00) Islamabad, Karachi, Tashkent","value":"Asia/Karachi"},
      {"label":"(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi","value":"Asia/Calcutta"},
      {"label":"(GMT+05:45) Kathmandu","value":"Asia/Katmandu"},
      {"label":"(GMT+06:00) Almaty, Novosibirsk","value":"Asia/Almaty"},
      {"label":"(GMT+06:00) Astana, Dhaka","value":"Asia/Dhaka"},
      {"label":"(GMT+06:30) Yangon (Rangoon)","value":"Asia/Rangoon"},
      {"label":"(GMT+07:00) Bangkok, Hanoi, Jakarta","value":"Asia/Bangkok"},
      {"label":"(GMT+07:00) Krasnoyarsk","value":"Asia/Krasnoyarsk"},
      {"label":"(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi","value":"Asia/Hong_Kong"},
      {"label":"(GMT+08:00) Kuala Lumpur, Singapore","value":"Asia/Kuala_Lumpur"},
      {"label":"(GMT+08:00) Irkutsk, Ulaan Bataar","value":"Asia/Irkutsk"},
      {"label":"(GMT+08:00) Perth","value":"Australia/Perth"},
      {"label":"(GMT+08:00) Taipei","value":"Asia/Taipei"},
      {"label":"(GMT+09:00) Osaka, Sapporo, Tokyo","value":"Asia/Tokyo"},
      {"label":"(GMT+09:00) Seoul","value":"Asia/Seoul"},
      {"label":"(GMT+09:00) Yakutsk","value":"Asia/Yakutsk"},
      {"label":"(GMT+09:30) Adelaide","value":"Australia/Adelaide"},
      {"label":"(GMT+09:30) Darwin","value":"Australia/Darwin"},
      {"label":"(GMT+10:00) Brisbane","value":"Australia/Brisbane"},
      {"label":"(GMT+10:00) Canberra, Melbourne, Sydney","value":"Australia/Canberra"},
      {"label":"(GMT+10:00) Hobart","value":"Australia/Hobart"},
      {"label":"(GMT+10:00) Guam, Port Moresby","value":"Pacific/Guam"},
      {"label":"(GMT+10:00) Vladivostok","value":"Asia/Vladivostok"},
      {"label":"(GMT+11:00) Magadan, Solomon Is., New Caledonia","value":"Asia/Magadan"},
      {"label":"(GMT+12:00) Auckland, Wellington","value":"Pacific/Auckland"},
      {"label":"(GMT+12:00) Fiji, Kamchatka, Marshall Is.","value":"Pacific/Fiji"},
      {"label":"(GMT+13:00) Nuku'alofa","value":"Pacific/Tongatapu"}
    ]


    export default {
        name: "Profile",
        mixins:[mixin],
        components:{
          XTable,
          Xupload
        },
        data(){
          return{
            form_extra: this.$form.createForm(this, {name: 'coordinated'}),
            model     : null,
            visible   : false,
            timeZone,
            cities    : [],
            groups    : [],
            profileSrc: null,
            loading   : false
          }
        },
        methods:{
          addSecureMsg(){
            this.visible = true
          },
          onCancel(){
            this.visible = false
          },
          profileUser(data){
            this.profileSrc = data.id
          },
          async getCity(){
            const { data } = await axios.post('/dictionary/country/')
            this.cities = data
          },
          async getGroups(){
            const { data } = await axios.get('/account/group/')
            this.groups = data
          },
          async getOneProfile(){
            try{
              this.loading = true
              const { data } = await axios.get('/account/')
              this.$refs.profile.imageUrl = data.avatar_url
              this.form_extra.setFieldsValue(data)
            }catch (e) {
              this.$message.error('Error receiving information')
            }finally {
              this.loading = false
            }
          },
          async getOneProfileOtherProfile(){
            try{
              this.loading = true
              const { data } = await axios.get('/setting/personal/profile/')
              this.form.setFieldsValue(data)
            }catch (e) {
              this.$message.error('Error receiving information')
            }finally {
              this.loading = false
            }
          },
          tabClick(tab){
            if(tab === '1'){
              this.getOneProfile()
            }else{
              this.getOneProfileOtherProfile()
            }
          },
           handleSubmitProfile(){
            this.form_extra.validateFields(async(err,values)=>{
              if(!err){
                try{
                  this.loading = true
                  values.avatar_id = this.profileSrc
                  const {data} = await axios.put('/account/', values)
                  this.$message.success('Profile Changed.')
                  localStorage.setItem('user',JSON.stringify(data))
                  this.$store.commit('UPDATE_PROFILE',data)
                  this.$emit('changeTab','UserSettingsNotifications')
                }catch (e) {
                  this.$notification['error']({
                    message: 'Error',
                    description: `Profile failed.`,
                  })
                }finally {
                  this.loading = false
                }
              }
            })
          },
          handleOtherProfile(){
            this.form.validateFields(async (err,values)=>{
              if(!err){
                try{
                  this.loading = true
                  await axios.put('/setting/personal/',{ profile: values })
                  this.$message.success('Profile changed.')
                  // this.$emit('changeTab','UserSettingsNotifications')
                }catch (e) {
                  this.$notification['error']({
                    message: 'Failed',
                    description: `Profile failed.`,
                  });
                }finally {
                  this.loading = false
                }
              }
            })
          },
        },
        created() {
          this.getCity()
          this.getGroups()
          this.getOneProfile()
          this.model = TableColMailDrop.default
        }
    }
</script>

<style>

  @import '../../../style/style.css';

  [dir] .select .ant-select-selection.ant-select-selection--single{
    border-radius: 3px !important;
  }
  [dir] .ant-input-group-addon{
    border-top-right-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
  }
  [dir] .vx-navbar-wrapper {
    z-index: 2 !important;
  }
  .billing .ant-input-group-addon{
    border-radius: 3px;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  .billing .ant-input{
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .profile-photo .ant-upload.ant-upload-select-picture-card{
    border-radius: 50% !important;
  }

</style>
